import { ErrorMessage } from '@hookform/error-message';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import { Controller, RegisterOptions } from 'react-hook-form';
export interface SelectInputBasicProps extends ISelectField {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  setSelectedValue?: any;
  menuPlacement?: 'auto' | 'bottom' | 'top';
  control?: any;
  errors?: any;
  searchable?: boolean;
  clearable?: boolean;
  label?: string;
  disabled?: boolean;
}
export const SelectInputBasic = ({
  name,
  options,
  rules,
  placeholder = 'Select...',
  menuPlacement = 'auto',
  searchable = true,
  control,
  label,
  labelIcon,
  clearable,
  disabled,
  errors,
  ...rest
}: SelectInputBasicProps) => {
  return (
    <>
      <Label label={label} labelIcon={labelIcon}>
        <Controller
          render={({ field: { onChange, value, ref } }) => (
            <SelectSearchDropDown
              searchable={searchable}
              disabled={disabled}
              clearable={clearable}
              options={options.map((o) => ({ id: o.value, label: o.label }))}
              placeHolder={placeholder}
              valueId={value}
              onChangeId={onChange}
              selectedItemSkin={(i) => i.label}
              optionItemSkin={(o) => o.label}
              searchFilter={(_) => {
                const search = _.toLowerCase();
                return options
                  .filter((option) =>
                    option.label.toLowerCase().includes(search),
                  )
                  .map((o) => ({ id: o.value, label: o.label }));
              }}
            />
          )}
          name={name}
          rules={rules}
          control={control}
          defaultValue=""
        />
        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        )}
      </Label>
    </>
  );
};
